module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-pg-soft.4aaf4c80.png";